import { BlockStack, Text } from '@shopify/polaris';
import { welcomeConfig } from '../../config';
import { stepSelector } from '@/redux/features/welcome.slice';
import { useSelector } from 'react-redux';
import { useMemo } from 'react';
import FinishStep from './components/FinishStep';

const WelcomeContent = () => {
  const currentStep = useSelector(stepSelector);

  const selectedWelcomeContent = useMemo(() => {
    return welcomeConfig.find(({ step }) => step === currentStep);
  }, [currentStep]);

  return (
    <BlockStack gap={selectedWelcomeContent ? '800' : '400'}>
      <BlockStack gap="400">
        {selectedWelcomeContent?.title && (
          <Text as="h1" variant="headingXl" alignment="center">
            {selectedWelcomeContent.title}
          </Text>
        )}
        {selectedWelcomeContent?.description && selectedWelcomeContent?.description.length > 0 && (
          <BlockStack gap="200">
            {selectedWelcomeContent?.description.map((item, index) => (
              <Text as="p" variant="bodyMd" key={index} alignment="center">
                {item as React.ReactNode}
              </Text>
            ))}
          </BlockStack>
        )}
      </BlockStack>

      {selectedWelcomeContent?.component || <FinishStep />}
    </BlockStack>
  );
};

export default WelcomeContent;
